// extracted by mini-css-extract-plugin
export default {"slider":"postProject_slider__17+p+","slider1":"postProject_slider1__zwwVy","scroll":"postProject_scroll__lQurO"};